
// CARRIERS > GETTERS

export default {
  allCarriers (state) {
    return state.carriers
  }
}